import styled from 'styled-components';

const ITEM_DIAM = 16;
const CIRCLE_DIAM = 8;

export const StyledCircle = styled.span<{
  $disabled: boolean;
  $checked: boolean;
}>(({
  $disabled,
  $checked,

  theme: {
    colors,
    radio,
  },
}) => ({
  boxSizing: 'border-box',
  display: 'flex',
  verticalAlign: 'text-bottom',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  left: 0,
  top: 0,
  width: ITEM_DIAM,
  height: ITEM_DIAM,
  borderRadius: ITEM_DIAM / 2,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: $disabled ? radio.COLORS.disabled[2] : radio.COLORS.default[2],
  backgroundColor: colors.NEUTRAL_WHITE,

  '&::before': {
    content: $checked ? '""' : undefined,
    boxSizing: 'border-box',
    display: 'inline-block',
    position: 'absolute',
    width: CIRCLE_DIAM,
    height: CIRCLE_DIAM,
    borderRadius: CIRCLE_DIAM / 2,
    backgroundColor: $disabled ? radio.COLORS.disabled[0] : radio.COLORS.checked[0],
  },
}));

export const StyledLabel = styled.label<{
  $disabled: boolean;
  $hasLabel: boolean;
}>(({
  $disabled,
  $hasLabel,

  theme: {
    indents,
    radio,
  },
}) => ({
  position: 'relative',
  paddingLeft: $hasLabel ? (ITEM_DIAM + indents.INDENT_1) : ITEM_DIAM,
  cursor: $disabled ? 'default' : 'pointer',
  color: $disabled ? radio.COLORS.disabled[1] : radio.COLORS.default[1],

  '&:hover': $disabled ? undefined : {
    color: radio.COLORS.hover[1],

    [StyledCircle]: {
      borderColor: radio.COLORS.checked[2],

      '&::before': {
        backgroundColor: radio.COLORS.checked[0],
      },
    },
  },

  '&:active': $disabled ? undefined : {
    color: radio.COLORS.active[1],

    [StyledCircle]: {
      borderColor: radio.COLORS.checked[2],

      '&::before': {
        backgroundColor: radio.COLORS.checked[0],
      },
    },
  },
}));

export const StyledInput = styled.input({
  display: 'none',
});

export const StyledContent = styled.span({
  display: 'inline-block',
});
